"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.regexp.split");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _otaManage = require("@/api/_homeCloudPlatform/ota/otaManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  computed: {
    rules: function rules() {
      var _this = this;
      return {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        ota_type: [{
          required: true,
          message: '请选择软件类型',
          trigger: 'change'
        }],
        device_type: [{
          required: true,
          message: '请选择设备类型',
          trigger: 'change'
        }],
        file_path: [{
          required: true,
          message: '请输入固件档案阿里云地址',
          trigger: 'blur'
        }, {
          max: 150,
          message: '输入长度不能超过150位'
        }, {
          validator: function validator(rule, value, callBack) {
            // TODO 驗證,網址規則
            // if (value) {
            //   callBack('多笔请使用「,」分隔')
            // } else {
            callBack();
            // }
          },
          trigger: 'submit'
        }],
        md5: [{
          required: true,
          message: '请输入MD5 checksum',
          trigger: 'blur'
        }, {
          max: 32,
          message: '输入长度不能超过32位'
        }],
        version: [{
          required: true,
          message: '请输入版本号',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        source_version: [
        // { required: true, message: '请选择OS版本编号' }
        {
          validator: function validator(rule, value, callBack) {
            // TODO 驗證,網址規則
            if (_this.formModel.source_version == '' && !_this.formModel.device_id_string) {
              callBack('请选择指定OS版本编号或指定设备编号');
            } else {
              callBack();
            }
          },
          trigger: 'submit'
        }],
        version_description: [{
          max: 300,
          message: '输入长度不能超过300位'
        }],
        device_id_string: [{
          max: 500,
          message: '输入长度不能超过500位',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callBack) {
            // TODO 驗證,分格規則
            // if (value) {
            //   callBack('多笔请使用「,」分隔')
            // } else {
            callBack();
            // }
          },
          trigger: 'submit'
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u56FA\u4EF6\u7248\u672C");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 預設排序,依創建時間遞減
      defaultOrdering: '-created_at',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20
      },
      dialogVisible: false,
      dialogType: 'view',
      // 狀態選項
      statusOptions: [{
        key: 0,
        display_name: '全部'
      }, {
        key: 1,
        display_name: '上架'
      }, {
        key: 2,
        display_name: '下架'
      }],
      // 軟件類型
      softwareTypeOptions: [{
        key: 0,
        display_name: '全部'
      }, {
        key: 1,
        display_name: 'OS'
      }, {
        key: 2,
        display_name: 'APK'
      }],
      // 設備類型
      deviceTypeOptions: [{
        key: 0,
        display_name: '全部'
      }, {
        key: 1,
        display_name: '到家版'
      }, {
        key: 3,
        display_name: '机构版'
      }],
      source_version: [],
      sourceVersionOptions: []
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
    this.getLourceVersionOptions();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList(e) {
      var _this2 = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _otaManage.getOtaList)(this.handleQuery()).then(function (res) {
        _this2.tableData = res || {};
        _this2.listLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.formModel = this.handleRowData(formModel);
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleView: function handleView(scope) {
      var _this4 = this;
      this.formModel = this.handleRowData(scope.row);
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this5 = this;
      this.formModel = this.handleRowData(scope.row);
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs['Form'].clearValidate();
      });
    },
    // handleDelete(scope) {
    //   this.$confirm('确认删除?', '警告', {
    //     confirmButtonText: '确认',
    //     cancelButtonText: '取消',
    //     type: 'error'
    //   })
    //     .then(async() => {
    //       await deleteProduct(scope.row.id)
    //       this.getList()
    //       this.$message({
    //         type: 'success',
    //         message: '成功删除!'
    //       })
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    // },
    // handleUpdateTest(scope) {},
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this6.dialogType === 'edit';
                  if (isEdit) {
                    (0, _otaManage.updateOta)(_this6.formModel.id, _this6.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this6.dialogType === 'add') {
                    (0, _otaManage.createOta)(_this6.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        _this6.formModel.source_version = _this6.source_version.split(',');
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleRowData: function handleRowData(data) {
      // 將字串轉成陣列
      if (typeof data.source_version === 'string' || !data.source_version) {
        data.source_version = data.source_version ? data.source_version.split(',') : [];
      }
      return JSON.parse(JSON.stringify(data));
    },
    handleFormData: function handleFormData() {
      if (this.formModel.ota_type === 1) {
        this.formModel.source_version = this.formModel.source_version.join(',');
        this.source_version = this.formModel.source_version;
      } else {
        this.formModel.source_version = function () {
          return;
        }();
        this.source_version = '';
      }
      // 新增時給固定md5
      // if (this.dialogType === 'add') {
      //   this.formModel.md5 = '97dec5f9036a2f00f6631db474070611'
      // }
      return this.formModel;
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.ota_status === '' || query.ota_status === 0) {
        query.ota_status = function () {
          return;
        }();
      }
      if (query.ota_type === '' || query.ota_type === 0) {
        query.ota_type = function () {
          return;
        }();
      }
      if (query.device_type === '' || query.device_type === 0) {
        query.device_type = function () {
          return;
        }();
      }
      return query;
    },
    handleSort: function handleSort(column) {
      // 初始化處理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 點擊排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    },
    // 取得所有"OS"版本編號
    getLourceVersionOptions: function getLourceVersionOptions() {
      var _this7 = this;
      // 取得所有
      (0, _otaManage.getOtaList)().then(function (response) {
        // if (!response.count) return
        (0, _otaManage.getOtaList)({
          page_size: response.count,
          ota_type: 1
        }).then(function (res) {
          _this7.sourceVersionOptions = res.results.length > 0 ? res.results : [{
            version: '0UCN__20230516'
          }]; //default base系统版本
        });
      });
    }
  }
};